import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SearchGlobal\SearchGlobalController::__invoke
* @see app/Http/Controllers/SearchGlobal/SearchGlobalController.php
* @route '/api/search-global'
*/
const SearchGlobalController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SearchGlobalController.url(options),
    method: 'get',
})

SearchGlobalController.definition = {
    methods: ["get","head"],
    url: '/api/search-global',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SearchGlobal\SearchGlobalController::__invoke
* @see app/Http/Controllers/SearchGlobal/SearchGlobalController.php
* @route '/api/search-global'
*/
SearchGlobalController.url = (options?: RouteQueryOptions) => {
    return SearchGlobalController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SearchGlobal\SearchGlobalController::__invoke
* @see app/Http/Controllers/SearchGlobal/SearchGlobalController.php
* @route '/api/search-global'
*/
SearchGlobalController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SearchGlobalController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SearchGlobal\SearchGlobalController::__invoke
* @see app/Http/Controllers/SearchGlobal/SearchGlobalController.php
* @route '/api/search-global'
*/
SearchGlobalController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: SearchGlobalController.url(options),
    method: 'head',
})

export default SearchGlobalController